// src/layouts/ReportLayout/index.tsx
import { FC, ReactNode } from "react";
import PropTypes from "prop-types";
import { Outlet } from "react-router-dom";
import Navbar from "src/components/home/Navbar";
import Footer from "src/components/home/Footer";
import { Container, Box } from "@mui/material";
import { usePullToRefresh } from "src/hooks/usePullToRefresh/usePullToRefresh";
import { PullToRefreshIndicator } from "src/components/common/PullToRefreshIndicator/PullToRefreshIndicator";

interface ReportLayoutProps {
  children?: ReactNode;
}

const ReportLayout: FC<ReportLayoutProps> = ({ children }) => {
  const isMobile = localStorage.getItem("isMobile");

  // Pull to refresh logic
  const handleRefresh = async () => {
    window.location.reload();
  };

  const { containerRef, isRefreshing, pullDistance, threshold } = 
    usePullToRefresh({ 
      onRefresh: handleRefresh,
      disabled: (isMobile == "false" || isMobile == null) // Disabled kalau bukan mobile
    });

  const shouldEnablePTR = !(isMobile == "false" || isMobile == null);

  return (
    <Box
      ref={shouldEnablePTR ? containerRef : null}
      sx={{
        background: `url(${process.env.REACT_APP_IMAGE_URL}static/images/placeholders/covers/report-bg.jpg)`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        ...(shouldEnablePTR && {
          height: "100vh",
          overflowY: "auto",
          overflowX: "hidden"
        })
      }}
    >
      {/* Refresh Indicator - Hanya untuk dashboard mobile */}
      {shouldEnablePTR && (
        <PullToRefreshIndicator
          isRefreshing={isRefreshing}
          pullDistance={pullDistance}
          threshold={threshold}
        />
      )}

      <Navbar />
      <Container
        maxWidth="lg"
        sx={{ 
          position: "relative", 
          marginTop: isMobile === "false" || isMobile === null ? "90px" : 1, 
          minHeight: "100vh" 
        }}
      >
        {children || <Outlet />}
      </Container>
      <Footer />
    </Box>
  );
};

ReportLayout.propTypes = {
  children: PropTypes.node,
};

export default ReportLayout;